import axios from 'axios';
import { useStorage } from '../hooks/use-storage';

function useAccountAddressesAPI() {
  const { userRef, menuIdRef, languageRef } = useStorage();

  function findAccountAddressesFromRemote() {
    const url = `/vbeta2/account/addresses`;

    return axios({
      url,
      method: 'get',
      headers: {
        'Content-Type': 'application/json',
        'Menu-Id': menuIdRef.current,
        'Accept-Language': languageRef.current?.tag,
        Authorization: `Bearer ${userRef?.current?.token}`,
      },
      responseType: 'json',
    });
  }

  function insertAccountAddressFromRemote(data) {
    const url = `/vbeta2/account/addresses`;

    return axios({
      url,
      data,
      method: 'post',
      headers: {
        'Content-Type': 'application/json',
        'Menu-Id': menuIdRef.current,
        'Accept-Language': languageRef.current?.tag,
        Authorization: `Bearer ${userRef?.current?.token}`,
      },
      responseType: 'json',
    });
  }

  function deleteAccountAddressFromRemote(id) {
    const url = `/vbeta2/account/addresses/${id}`;

    return axios({
      url,
      method: 'delete',
      headers: {
        'Content-Type': 'application/json',
        'Menu-Id': menuIdRef.current,
        'Accept-Language': languageRef.current?.tag,
        Authorization: `Bearer ${userRef?.current?.token}`,
      },
      responseType: 'json',
    });
  }

  return {
    findAccountAddressesFromRemote,
    insertAccountAddressFromRemote,
    deleteAccountAddressFromRemote,
  };
}

export { useAccountAddressesAPI };
